import { ContactsQuery } from '../../models/contacts-query';
import { Contact } from '../../models/contact';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface ContactsTableState {
    query: ContactsQuery;
    page: Contact[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    saving: boolean;
    deleting: boolean;
    selection: string[];
}

export const selectContactsTableState = (state: AppState) => state.contactsTable;

export const selectContactsTableQuery = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.query);

export const selectContactsTablePage = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.page);

export const selectContactsTableBusy = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.busy);

export const selectContactsTableCount = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.totalCount);

export const selectContactsTableSelection = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.selection);

export const selectContactSaving = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.saving);

export const selectContactDeleting = createSelector(selectContactsTableState,
    (state: ContactsTableState) => state.deleting);
